import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SharedTableHeader } from "./SharedTableHeader";
import { SharedTableBody } from "./SharedTableBody";
export function SharedTable(props) {
    const { data, columnDefinitions, visibilityConfig, columnWidths, sortOption, onSortChange, stickyOffset = 0, className, headerClassName, subHeaderClassName, bodyClassName, rowBodyClassName, additionalColumns = {}, // для дополнительных колонок, которых нет в itemsOrder
    alwaysVisibleColumnId = 6, // id колонки к которой добавляется ширина скрытых колонок
    BodyComponent = SharedTableBody, redistributeHiddenWidth = true, highlightedStatuses = {}, getRowHighlightClassName, columnWidthCssVars = false, containerRef, renderColumnResizeHandle, } = props;
    const { itemsChecked, itemsOrder } = visibilityConfig;
    const allColumnDefinitions = {
        ...columnDefinitions,
        ...additionalColumns,
    };
    const visibleColumns = [
        ...itemsOrder.filter((id) => itemsChecked[id]),
        ...Object.keys(additionalColumns).map(Number),
    ];
    const hiddenColumns = [
        ...itemsOrder.filter((id) => !itemsChecked[id]),
        ...Object.keys(additionalColumns).map(Number),
    ];
    const adjustedColumnDefinitions = {
        ...allColumnDefinitions,
    };
    if (redistributeHiddenWidth &&
        visibleColumns.includes(alwaysVisibleColumnId)) {
        const extraWidth = hiddenColumns.reduce((sum, colId) => sum + (columnWidths[colId] || 0), 0);
        const baseWidth = columnWidths[alwaysVisibleColumnId] || 0;
        adjustedColumnDefinitions[alwaysVisibleColumnId] = {
            ...adjustedColumnDefinitions[alwaysVisibleColumnId],
            width: `${baseWidth + extraWidth}px`,
        };
    }
    visibleColumns.forEach((colId) => {
        if (colId !== alwaysVisibleColumnId &&
            adjustedColumnDefinitions[colId] &&
            !adjustedColumnDefinitions[colId].width) {
            adjustedColumnDefinitions[colId] = {
                ...adjustedColumnDefinitions[colId],
                width: `${columnWidths[colId] || 0}px`,
            };
        }
    });
    const getTrackSize = (colId) => adjustedColumnDefinitions[colId]?.width || "auto";
    const gridTemplateColumns = columnWidthCssVars
        ? visibleColumns.map((colId) => `var(--col-${colId})`).join(" ")
        : visibleColumns.map((colId) => getTrackSize(colId)).join(" ");
    let columnSizeStyle;
    if (columnWidthCssVars) {
        const columnVars = {};
        visibleColumns.forEach((colId) => {
            columnVars[`--col-${colId}`] = getTrackSize(colId);
        });
        columnSizeStyle = columnVars;
    }
    const hasSubHeader = visibleColumns.some((colId) => adjustedColumnDefinitions[colId]?.renderSubHeader);
    return (_jsxs("div", { ref: containerRef, className: className, style: columnSizeStyle, children: [_jsx(SharedTableHeader, { visibleColumns: visibleColumns, adjustedColumns: adjustedColumnDefinitions, sortOption: sortOption, onSortChange: onSortChange, stickyOffset: stickyOffset, headerClassName: headerClassName, subHeaderClassName: subHeaderClassName, gridTemplateColumns: gridTemplateColumns, hasSubHeader: hasSubHeader, renderColumnResizeHandle: renderColumnResizeHandle }), _jsx(BodyComponent, { data: data, visibleColumns: visibleColumns, adjustedColumns: adjustedColumnDefinitions, bodyClassName: bodyClassName, rowBodyClassName: rowBodyClassName, gridTemplateColumns: gridTemplateColumns, highlightedStatuses: highlightedStatuses, getRowHighlightClassName: getRowHighlightClassName })] }));
}
